import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3C6.67856 3 2.25 6.96968 2.25 12C2.25 14.3148 3.19638 16.4169 4.73421 18.0017C5.09205 18.3722 5.19092 18.7062 5.13253 18.9346C4.9921 19.4817 4.72927 19.9901 4.36395 20.421C4.19049 20.6255 4.13948 20.9072 4.23017 21.1596C4.32085 21.412 4.53943 21.5968 4.80342 21.6442C5.19832 21.7151 5.59989 21.7505 6.00111 21.75C7.31588 21.7498 8.54445 21.373 9.58281 20.7216C10.3572 20.9041 11.1676 21 12 21C17.3214 21 21.75 17.0303 21.75 12C21.75 6.96968 17.3214 3 12 3ZM3.75 12C3.75 7.91832 7.38144 4.5 12 4.5C16.6186 4.5 20.25 7.91832 20.25 12C20.25 16.0817 16.6186 19.5 12 19.5C11.179 19.5 10.3872 19.3917 9.64158 19.1892C9.42637 19.1308 9.19632 19.1711 9.01385 19.2993C8.22397 19.8543 7.27501 20.1968 6.24719 20.2443C6.38904 19.9444 6.50256 19.6305 6.58553 19.3072C6.83498 18.3336 6.31791 17.482 5.8123 16.9588L5.81121 16.9577C4.52138 15.6286 3.75 13.8929 3.75 12Z"
        fill={colorValue}
      />
    </svg>
  );
};
